module.exports = __webpack_public_path__ + "img/grow-one-for-good.64d797e1.jpg";